import React from 'react'
import {Container} from 'react-bootstrap'
import ModelCard from './components/ModelCard'

import models from './components/config/models.json'

export default function MainLift(props) {

  const handleSelect = model=>{
    props.config.lift.model = model;
    props.select( props.config );
  }

  const modelcards = models.map( (card)=>{
    const selected = props.config.lift.model && (props.config.lift.model.modelname===card.modelname)
    return (
        <ModelCard 
            key = {card.modelname}
            modelname = {card.modelname}
            dimensions = {card.dimensions}
            capacity = {card.capacity}
            select = {handleSelect}
            selected = {selected}
        />
    )
  })

  return(
    <Container className='model-card-container'>
        <h1 className='text-white col-12' style={{marginBottom: '3rem'}}>Choose your Leggera model</h1>
        
        {modelcards}
        
    </Container>
  )
}
